import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a47f91"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "multipleSelectRef",
  class: "multiple-select"
}
const _hoisted_2 = { class: "multiple-select__main" }
const _hoisted_3 = { class: "main__selectable" }
const _hoisted_4 = {
  key: 0,
  class: "content__search"
}
const _hoisted_5 = {
  key: 1,
  class: "content__options"
}
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = {
  key: 0,
  class: "iconfont icon-duigou"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  ref: "mainSelectRef",
  class: "main__selected mk-text-overflow"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "selected__count"
}

import { ref, watch, inject } from 'vue'
import { getGenresApi } from '@/api/vod'
import { useGenresList } from '@/utils/cacheData'


const __default__ = {
  name: "MultipleSelect",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 已选数据，为了实现 v-model
  modelValue: {
    type: Array,
    default: () => []
  },
  widget: {
    type: Object,
    default: () => ({})
  },

  // 下拉选择的数据
  // optionList: {
  //   type: Array,
  //   default: () => []
  // },

  // 获取 name 字段
  nameField: {
    type: String,
    default: () => 'name'
  },

  // 获取 value 字段
  valueField: {
    type: String,
    default: () => 'id'
  },

  // 是否支持搜索
  showSearch: {
    type: Boolean,
    default: () => false
  },

  // 是否区分大小写
  caseSensitive: {
    type: Boolean,
    default: () => false
  },

  // 是否显示 全部 选项
  showAllOption: {
    type: Boolean,
    default: () => true
  },

  // 全部选择默认的值
  allOptionValue: {
    type: [String, Number],
    default: () => 'all'
  },

  // 所选值受控，默认不受控，会在内部处理关于全部选项的逻辑，配置为受控时，不会再处理这部分逻辑
  valueControlled: {
    type: Boolean,
    default: () => false
  },
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false
  },

  searchData: {
    type: Object,
    default: {}
  },
  programType: {
    type: Number,
    default: 0
  }
},
  emits: ['update:modelValue', 'change', 'option-click'],
  setup(__props, { emit }) {

const props = __props;

const cloneModelValue = ref([])



const languageOptions: any = inject('languageOptions')


// 获取语言全称
const getLanguageName = (val) => {
  const item = languageOptions.value.filter(item => {
    return item.label === val
  })
  return item[0].value
}

// 获取分类属性
const getGenres = async () => {
  // console.log('props.programType', props.programType);
  if (props.searchData.language) {
    // let params = {
    //   language: getLanguageName(props.searchData.language),
    //   type: props.programType
    // }
    const res = await useGenresList(getLanguageName(props.searchData.language), props.programType)
    optionList.value = res

  }

}




watch(() => [props.searchData.language, props.programType], (val) => {
  getGenres()
}, {
  immediate: true,
  deep: true
})

const optionList = ref([])


const selectedList = ref([])
// 搜索的值
const searchValue = ref('');
// 缓存的选项（不使用 reactive 的原因是 reactive 一旦定义了，就不能直接替换整个对象，否则会丢失原有的响应式，而 ref 不会）
const cacheOptionList = ref([])
// popover 宽度
const popoverWidth = ref('200px');
// 显示的选项
const showOptionList = ref([])

// 获取显示名
const getDisplayName = (selectedItem, selectedIndex) => {
  // console.log('selectedItem, selectedIndex', selectedItem, selectedIndex, typeof selectedItem);

  let target;
  for (let i = 0, len = cacheOptionList.value.length; i < len; i++) {
    if (typeof selectedItem !== 'object' && selectedItem === cacheOptionList.value[i][props.valueField]) {
      target = cacheOptionList.value[i];
    }
    if (typeof selectedItem === 'object' && selectedItem[props.valueField] === cacheOptionList.value[i][props.valueField]) {
      target = cacheOptionList.value[i];
    }
  }
  // console.log('target', target);

  return target ? target[props.nameField] : selectedItem;
}



const mainSelectWrapRef = ref(null)
// 已选展示区域点击事件
const onMainSelectWrapClick = () => {
  if (!props.disabled) {
    let clientWidth = mainSelectWrapRef.value.clientWidth;
    // 最小宽度为 200px
    clientWidth = clientWidth > 200 ? clientWidth : 200;
    popoverWidth.value = clientWidth + 'px';
  } else {
    console.log('已禁用')
  }
}

// 弹框各项点击事件
const optionItemClick = (item) => {
  let itemValue = item[props.valueField];
  let copyList = JSON.parse(JSON.stringify(selectedList.value))
  let index = copyList.findIndex(item => item[props.valueField] === itemValue);

  if (index !== -1) {
    // 已选，则删除
    copyList.splice(index, 1);
  } else {
    if (!props.valueControlled) {
      // 所选值不受控（内部控制）
      if (props.showAllOption && itemValue === props.allOptionValue) {
        // 证明选择的是全部，只保留全部的值
        copyList = [itemValue];
      } else {
        // 证明现在选的不是全部选项，在 copyList 中寻找全部选项的位置，有就删除
        let targetIndex = copyList.indexOf(props.allOptionValue);
        targetIndex > -1 && copyList.splice(targetIndex, 1);
        // 加入所选值
        copyList.push(item);
      }
    } else {
      // 所选值受控
      // 加入所选值
      copyList.push(item);
    }
  }
  emit('update:modelValue', copyList);
  emit('change', copyList);
  // 下拉选择项点击事件参数分别为 点击项对象     是否选中
  emit('option-click', item, index !== -1 ? false : true);
}

// multiple selector hide event
const multipleSelectHide = () => {
  let copyList = JSON.parse(JSON.stringify(selectedList.value))
  const { func } = props.widget
  func && func(copyList)
}

// 搜索框输入事件
const onSearchInput = (value) => {
  value = (value === 0 || value) ? (value + '') : '';
  showOptionList.value = cacheOptionList.value.filter(item => {
    let name = item[props.nameField];
    // 防止传入的 name 不是字符类型
    name = (name === 0 || name) ? (name + '') : '';

    if (!props.caseSensitive) {
      // 不区分大小写
      return name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    } else {
      return name.indexOf(value) !== -1;
    }
  });
}

const onSelectedItemDelete = (selectedItem, selectedIndex) => {
  if (!props.disabled) {
    selectedList.value.splice(selectedIndex, 1);
    emit('update:modelValue', selectedList.value);
    emit('change', selectedList.value);
  } else {
    console.log('已禁用')
  }
}

// 要监听对象属性或非基本类型时，第一个参数必须用函数式
watch(() => props.modelValue, (newVal, oldVal) => {
  // console.log(' props.modelValue', props.modelValue);

  selectedList.value = JSON.parse(JSON.stringify(newVal || []));
  cloneModelValue.value = JSON.parse(JSON.stringify(props.modelValue))
}, {
  immediate: true,
  // deep: true
})

watch(() => JSON.parse(JSON.stringify(optionList.value)), (newVal, oldVal) => {
  cacheOptionList.value = JSON.parse(JSON.stringify(newVal || []));
  if (cacheOptionList.value && cacheOptionList.value.length > 0) {
    if (props.showAllOption) {
      // 加入全部选项
      let allOption = {};
      allOption[props.nameField] = '全部';
      allOption[props.valueField] = props.allOptionValue;
      cacheOptionList.value = [allOption].concat(cacheOptionList.value);
    }
  }
  showOptionList.value = cacheOptionList.value;
}, {
  immediate: true,
  // deep: true
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_popover, {
        trigger: "click",
        placement: "bottom",
        "popper-class": "multiple-select__main__popover mk-popper-default",
        width: popoverWidth.value,
        disabled: __props.disabled,
        onHide: multipleSelectHide
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "mainSelectWrapRef",
            ref: mainSelectWrapRef,
            class: _normalizeClass(['main__selected-warp', { 'main__selected-warp_disabled': __props.disabled }]),
            onClick: onMainSelectWrapClick
          }, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((selectedList.value || []), (selectedItem, selectedIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: selectedIndex,
                  class: "selected__item"
                }, [
                  _createElementVNode("span", null, _toDisplayString(getDisplayName(selectedItem, selectedIndex)), 1),
                  _createElementVNode("i", {
                    class: "item__delete iconfont icon-cuo",
                    onClick: ($event: any) => (onSelectedItemDelete(selectedItem, selectedIndex))
                  }, null, 8, _hoisted_10)
                ]))
              }), 128))
            ], 512),
            (selectedList.value && selectedList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.modelValue.length < 100 ?
                __props.modelValue.length : "99+"), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (__props.showSearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: cloneModelValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cloneModelValue).value = $event))
                  }, null, 8, ["modelValue"]), [
                    [_vShow, false]
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: searchValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                    onInput: onSearchInput,
                    clearable: true
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (showOptionList.value && showOptionList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((showOptionList.value || []), (optionItem, optionIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: optionIndex,
                      onClick: ($event: any) => (optionItemClick(optionItem)),
                      class: "options__item mk-text-overflow",
                      title: optionItem[__props.nameField]
                    }, [
                      _createElementVNode("span", null, _toDisplayString(optionItem[__props.nameField]), 1),
                      (__props.modelValue.findIndex(item => item[__props.valueField] === optionItem[__props.valueField]) !== -1)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_empty)
                ]))
          ])
        ]),
        _: 1
      }, 8, ["width", "disabled"])
    ])
  ], 512))
}
}

})